import { createTheme } from '@mui/material';

const theme = createTheme({
  colors: {
    white: '#ffffff',
    darkWhite: '#eaeaea',
    lightGray: '#f2f2f2',
    mediumGray: '#f6f6f6',
    translucentText: '#DCDCDC',
    border: '#D9D9D9',
    gray: '#bdb6b6',
    grayText: '#CACACA',
    inactiveText: '#909090',
    fadedText: '#AEAEAE',
    fadedIcon: '#919191',
    darkerGray: '#616161',
    darkYellow: '#FF9900',
    soilOrange: '#EB612C',
    lightOrange: '#ff6b00',
    rustRed: '#C52C03',
    americanGreen: '#4AA844',
    brown: 'rgba(255, 46, 0, 0.23)',
    darkBrown: 'rgba(235, 97, 44, 0.15)',
    mainText: '#2E314E',
    mainTextDark: '#171E3C',
    darkBlue: 'rgba(22, 37, 77, 0.06)',
    whiteSmoke: '#EFEFEF',
    mountainGreen: '#16AD77',
    veryLightGray: '#CDCDCD',
    darkerGray2: '#646464',
    darkOrangeBar: '#C46F31',
    orangeBar: '#FF9344',
  },
});

export default theme;
